import Plyr from 'plyr';
import barba from '@barba/core';

let options = {
    controls: ['play-large', 'mute', 'progress', 'current-time'],
};

let referenceOptions = {
    controls: [],
    muted: true,
    playsinline: true,
};

(($) => {
    const initPlyr = () => {
        $('.wp-block-video:not(.is-initialized)').each(function () {
            $(this).addClass('is-initialized');
            if ($(this).closest('.single-reference').length > 0) {
                options = referenceOptions;
            } else if ($(this).hasClass('is-style-no-controls')) {
                options = {
                    controls: [],
                    muted: true,
                    playsinline: true,
                };
            }

            const player = new Plyr($(this).find('video'), options);
        });
    };

    barba.hooks.beforeEnter(initPlyr);
    document.addEventListener('DOMContentLoaded', initPlyr);

    // check to play reference videos only in viewport
    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio < 0.25) {
                    entry.target.pause();
                } else if (entry.intersectionRatio >= 0.25) {
                    entry.target.play();
                }
            });
        },
        { threshold: [0, 0.25, 0.5, 0.75, 1] }
    );

    const initViewPortCheck = () => {
        let videos = document.querySelectorAll(
            '.references__list__item__video'
        );

        const referenceVideos = document.querySelectorAll(
            '.single-reference .wp-block-video video'
        );

        videos = [...videos, ...referenceVideos];

        for (var i = 0; i < videos.length; i++) {
            const video = videos[i];
            observer.observe(video);
        }
    };

    const resetViewPortCheck = () => {
        observer.disconnect();
    };

    const mouseOverHandler = (e) => {
        e.target.play();
    };

    const mouseLeaveHandler = (e) => {
        e.target.pause();
    };

    const activeSlideHandler = (e) => {
        const activeSlide = e.target.querySelector(
            '.swiper-slide-active .reference-slider__video'
        );
        activeSlide.play();

        const videos = e.target.querySelectorAll('.reference-slider__video');
        videos.forEach((video) => {
            if (video !== activeSlide) {
                video.pause();
            }
        });
    };

    const initHoverCheck = () => {
        const videos = document.querySelectorAll('.reference-slider__video');

        if (videos.length === 0) {
            return;
        }

        const checkConditions = () => {
            if (window.innerWidth <= 768) {
                removeHover(videos);
            } else {
                addHover(videos);
            }
        };

        const addHover = (videos) => {
            videos.forEach((video) => {
                video.addEventListener('mouseenter', mouseOverHandler);
                video.addEventListener('mouseleave', mouseLeaveHandler);
                video.pause();
            });
        };

        const removeHover = (videos) => {
            if (videos) {
                videos.forEach((video) => {
                    video.removeEventListener('mouseenter', mouseOverHandler);
                    video.removeEventListener('mouseleave', mouseLeaveHandler);
                    video.pause();

                    const activeSlide = video.closest('.swiper-slide-active');

                    if (activeSlide) {
                        const activeSlideVideo = activeSlide.querySelector(
                            '.reference-slider__video'
                        );

                        if (activeSlideVideo) {
                            activeSlideVideo.play();
                        }
                    }
                });
            }
        };

        window.addEventListener('resize', checkConditions);
        window.addEventListener('load', checkConditions);

        checkConditions();
    };

    barba.hooks.beforeEnter(initViewPortCheck);
    barba.hooks.beforeEnter(initHoverCheck);
    barba.hooks.afterLeave(resetViewPortCheck);
    document.addEventListener('DOMContentLoaded', initViewPortCheck);
    document.addEventListener('DOMContentLoaded', initHoverCheck);
})(window.jQuery);
